export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  accountabilitys: [],
  years: {},
  entity: 'accountability',
  entities: 'accountabilitys',
  prefixRouter: 'dweller.accountability'
})



// WEBPACK FOOTER //
// ./src/app/dweller/accountability/resources/data.js